<template>
  <div class="telemed-carousel user-select-none">
    <div class="mx-2 d-flex justify-center">
      <v-img
        src="/images/features/clinic/laptop.png"
        max-width="819px"
        aspect-ratio="1.69917012448"
      >
        <div class="telemed-carousel__content">
          <v-carousel
            v-model="currentItem"
            height="100%"
            :show-arrows="false"
            hide-delimiters
          >
            <v-carousel-item
              v-for="i in carouselItemsCount"
              :key="i"
              :value="i"
            >
              <v-img
                width="100%"
                height="100%"
                aspect-ratio="1.77202072539"
                :alt="`Пример работы телемед-консультации №${i}`"
                :src="`/images/features/clinic/telemed_carousel_item_${i}.png`"
                :srcset="`/images/features/clinic/telemed_carousel_item_${i}.png 1x,
                                        /images/features/clinic/telemed_carousel_item_${i}_3x.png 3x`"
              />
            </v-carousel-item>
          </v-carousel>
          <v-btn
            height="32"
            width="32"
            color="ui-kit-text-info"
            class="mr-7 telemed-carousel__arrow telemed-carousel__arrow_left bg-ui-kit-bg-gray-40 rounded-lg"
            icon
            @click="handleClickLeftArrow"
          >
            <v-icon
              size="20"
              color="ui-kit-icon-secondary"
            >
              ui-icon-arrow-left
            </v-icon>
          </v-btn>
          <v-btn
            height="32"
            width="32"
            color="ui-kit-text-info"
            class="ml-7 telemed-carousel__arrow telemed-carousel__arrow_right bg-ui-kit-bg-gray-40 rounded-lg"
            icon
            @click="handleClickRightArrow"
          >
            <v-icon
              size="20"
              color="ui-kit-icon-secondary"
            >
              ui-icon-arrow-right
            </v-icon>
          </v-btn>
        </div>
      </v-img>
    </div>

    <div class="mt-6 ml-n2 d-flex justify-center">
      <span
        v-for="i in carouselItemsCount"
        :key="i"
        class="ml-2 cursor-pointer d-block rounded-circle telemed-carousel__delimeter"
        :class="i === currentItem ? 'bg-primary' : 'bg-ui-kit-bg-gray-60'"
        @click="handleClickCarouselPoint(i)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const carouselItemsCount = 3
let currentCarouselInterval = 0

const currentItem = ref(1)

onMounted(() => {
  if (import.meta.server) {
    return
  }

  resetInterval()
})

watch(currentItem, (val) => {
  resetInterval()

  if (val > carouselItemsCount || val <= 0) {
    currentItem.value = 1
  }
})

function resetInterval() {
  window.clearInterval(currentCarouselInterval)
  currentCarouselInterval = window.setInterval(() => {
    currentItem.value++
  }, 5000)
}

function handleClickCarouselPoint(index: number) {
  currentItem.value = index
}

function handleClickLeftArrow() {
  currentItem.value = (currentItem.value === 1 ? carouselItemsCount : currentItem.value - 1)
}

function handleClickRightArrow() {
  currentItem.value++
}
</script>

<style lang="scss" scoped>
.telemed-carousel {
  &__content {
    position: absolute;
    top: 3.8%;  // рамка ноутбука, 18px при максимальном размере
    left: 50%;
    transform: translateX(-50%);
    height: 80.083%; // высота дисплея ноутбука
    aspect-ratio: 1.772;
  }

  &__delimeter {
    width: 8px;
    height: 8px;
  }

  &__arrow {
    position: absolute;
    top: 50%;

    &_left {
      right: 100%;
    }

    &_right {
      left: 100%;
    }
  }
}
</style>
